var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRichtext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2026_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_572_",
    d: "M24.4,26H1.6C0.7,26,0,25.3,0,24.4V1.6C0,0.7,0.7,0,1.6,0h22.8C25.3,0,26,0.7,26,1.6v22.8 C26,25.3,25.3,26,24.4,26z M1.6,1.6v22.8h22.8V1.6H1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_73_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1205_",
    d: "M17.1,19.9v-0.8c0-0.2,0.2-0.4,0.4-0.4h4.9c0.2,0,0.4,0.2,0.4,0.4v0.8c0,0.2-0.2,0.4-0.4,0.4h-4.9 C17.2,20.3,17.1,20.1,17.1,19.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_590_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    d: "M3.1,8.5h2.7C7,8.5,7.9,8.7,8.5,9C9,9.4,9.3,9.9,9.3,10.7c0,0.5-0.1,0.9-0.4,1.3c-0.2,0.3-0.6,0.5-1,0.6 v0.1c0.6,0.1,0.9,0.4,1.2,0.7c0.2,0.3,0.4,0.8,0.4,1.3c0,0.8-0.3,1.4-0.9,1.9c-0.6,0.4-1.4,0.7-2.3,0.7H3.1V8.5z M4.9,11.9H6 c0.5,0,0.9-0.1,1.1-0.2c0.2-0.2,0.3-0.4,0.3-0.8c0-0.3-0.1-0.6-0.4-0.7C6.8,10.1,6.4,10,5.9,10h-1V11.9z M4.9,13.4v2.3h1.2 c0.5,0,0.9-0.1,1.1-0.3c0.2-0.2,0.4-0.5,0.4-0.9c0-0.7-0.5-1.1-1.5-1.1H4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_69_",
    d: "M14.8,8.5l-3.2,8.7h-1.3l3.2-8.7H14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    d: "M22.9,8.5v5.6c0,0.6-0.1,1.2-0.4,1.7c-0.3,0.5-0.7,0.9-1.2,1.1c-0.5,0.3-1.1,0.4-1.9,0.4 c-1.1,0-1.9-0.3-2.5-0.9S16,15.1,16,14.1V8.5h1.4V14c0,0.7,0.2,1.2,0.5,1.6s0.8,0.5,1.5,0.5c1.3,0,2-0.7,2-2.1V8.5H22.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRichtext);
export default __webpack_public_path__ + "static/media/Richtext.8fbb2dfe4612bf96de2a6306b86a84d8.svg";
export { ForwardRef as ReactComponent };